export const FACILITY_LOADED_SUCCESS = 'FACILITY_LOADED_SUCCESS';
export const FACILITY_LOADED_FAILURE = 'FACILITY_LOADED_FAILURE';
export const FACILITY_FAQ_LOADED_SUCCESS = 'FACILITY_FAQ_LOADED_SUCCESS';
export const FACILITY_FAQ_LOADED_FAILURE = 'FACILITY_FAQ_LOADED_FAILURE';
export const USEFUL_LINKS_LOADED_SUCCESS = 'FACILITY_FAQ_LOADED_SUCCESS';
export const USEFUL_LINKS_LOADED_FAILURE = 'FACILITY_FAQ_LOADED_FAILURE';
export const DOWNLOADABLE_FORM_LOADED_SUCCESS = 'DOWNLOADABLE_FORMS_LOADED_SUCCESS';
export const DOWNLOADABLE_FORMS_LOADED_SUCCESS = 'DOWNLOADABLE_FORMS_LOADED_SUCCESS';
export const DOWNLOADABLE_FORMS_LOADED_FAILURE = 'DOWNLOADABLE_FORMS_LOADED_FAILURE';
export const FACILITY_LOGO_LOADED = 'FACILITY_LOGO_LOADED';
export const SINGLE_DOWNLOAD_LOADED = 'SINGLE_DOWNLOAD_LOADED';